import React, { useContext, useEffect, useState } from "react";
import cardImg from "../assets/images/cardImg.svg";
import blue_email from "../assets/images/blue_email.svg";
import { AppContext } from "../contaxt/AppContext";
import ShieldQuestion from "../assets/images/sheildWhite.svg";
import AccessTime from "../assets/images/clockWhite.svg";
import nextplan from "../assets/images/nextplan.svg";
import { useNavigate } from "react-router-dom";
import thumbsup from "../assets/images/thumbs-up.svg";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import activeThumsUp from "../assets/images/activeThumsUp.svg";
import thumbsdown from "../assets/images/thumbs-down.svg";
import activethumpsdown from "../assets/images/thumbsdownWhitediff.svg";
import Satisfied from "../assets/images/satisfied.svg";
import Enthusiastic from "../assets/images/Enthusiastic.svg";
import Diplomatic from "../assets/images/diplomatic.svg";
import Cautious from "../assets/images/Cautious.svg";
import arrowRight from "../assets/images/arrow-right.svg";
import saveIcon from "../assets/images/Icon.svg";
import languageIcon from "../assets/images/languageBlue.svg";
import mobSaveIcon from "../assets/images/SaveBlue.svg";
import editProfileIcon from "../assets/images/editProfileBlue.svg";
import CheckCircleIcon from "../assets/images/checkGrey.svg";
import CheckCircleActvIcon from "../assets/images/checkGreen.svg";
import VerifiedUserWhite from "../assets/images/VerifiedUserWhite.svg";
import arrowUp from "../assets/images/ChevronUp.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateData } from "../redux/roundtoSlice";
import { lungueges } from "../constant/lungueges";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import questionmark from "../assets/images/Questionmark.svg";
import vector from "../assets/images/Vector1.svg";
import Stacked from "../assets/images/Trending up1.svg";
import Group from "../assets/images/Lightbulb outline1.svg";
import Frame from "../assets/images/Rocket launch1.svg";
import File from "../assets/images/Summarize1.svg";
export default function Lywomultipleexit() {
  const state = useSelector((state) => state.roundData);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const { isNormal, SetChangeLang } = useContext(AppContext);

  const { i18n, t } = useTranslation();

  const currentStep = 1;

  const getProgressWidth = () => {
    if (currentStep === 1) return "33%";
    if (currentStep === 2) return "33%";
    if (currentStep === 3) return "33%";
  };

  const [showLanguagePopup, setShowLanguagePopup] = useState(false);

  const [showExitModal, setShowExitModal] = useState(false);

  const editProfile = () => {
    dispatch(updateData({ field: "isEditDetails", value: true }));
    navigate("/JobApplicationProcess", { state: { fromOtherPage: true } });
  };
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile(); // initial check
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const quizSteps = [
    {
      title: "Because You’re More Than Just a Resume",
      subtitle: "Uncover strengths and traits your CV can’t capture.",
      icon: vector,
      variant: "#fcfcfd",
      smallbox: "#EFF6FF",
    },
    {
      title: "Show Your True Potential",
      subtitle: "Shine in a calm, bias-free environment — no panel pressure",

      icon: Frame,
      variant: "#FCFCFD",
      smallbox: "#EFFDF4",
    },
    {
      title: "Insight That Moves You Forward",
      subtitle: "Get data-backed feedback to guide your growth journey.",

      icon: Stacked,
      variant: "#FCFCFD",
      smallbox: "#FFF7ED",
    },
    {
      title: "Fair, Objective, Transparent",
      subtitle: "Let your strengths speak — with metrics that remove bias.",
      icon: File,
      variant: "#FCFCFD",
      smallbox: "#FAF5FF",
    },
    {
      title: "Quick Tip",
      subtitle:
        "Answer honestly and trust your first instinct. There are no right or wrong answers !",
      icon: Group,
      variant: "#fff9e6",
      smallbox: "#FCFCFD",
    },
  ];

  return (
    <>
      <div className="paGeWrap m-botm" style={{ backgroundColor: '#fbfbfc' }}>
        <div className="paGeWrap-pdg">
          <div className="container colCntR">
            <h3>Dear {state.userName}</h3>
            <h4>Your preliminary Information is received</h4>
            <div className="col-12 col-md-10 col-lg-8 emailNotifiTxt mobBgWrap">
              <p>
                <img src={blue_email} className="blueEmailIcon mb-1" />
                We will send you an update on{" "}
                <span className="eMailaDrs">{state.userEmail}</span>
              </p>
            </div>
            <div className="col-12 col-md-10 col-lg-8 mobBgWrap1">
              <div className="progressbarWrap">
                <div className="progressBarContainer">
                  <div
                    className="progressFill"
                    style={{ width: getProgressWidth() }}
                  ></div>
                  {/* <div className="progressDots">
                  <div className="dummyDot"></div>
                  <div className={`${currentStep === 1}`}></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div> */}
                </div>

                <div className="mileStoneTxtnew">
                 
                  <div className="milstnTxtImgnew">
                 
                    <img src={CheckCircleActvIcon} className="checkIcon" />
                    <p className="mileStoneActv"> Info</p></div>
      
                  <div className="milstnTxtImgnew">
                    <img src={CheckCircleIcon} className="checkIcon" />
                    <p>Behavior</p>
                  </div>
                  <div className="milstnTxtImgnew">
                    <img src={CheckCircleIcon} className="checkIcon" />
                    <p>MCQ</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-10 col-lg-8 mobBgWrap1">
              <div className="behavr-box-wrap">
                <div className="behavr-txt-box pb-0">
                  <h2 className="next-step-lywoexit mb-0 text-center">
                    The Next Step is a Behaviour Assessment
                  </h2>
                </div>

                <div className="ARW-sec-flshScrn pt-0">
                  <div
                    className="pers-testexit "
                    style={{ marginBottom: "8px" }}
                  >
                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      className="smallText"
                    >
                      <p style={{ display: "contents" }}>
                        Why do we conduct a Multiple Choice Quiz{" "}
                      </p>
                      <img src={questionmark} width={16} height={16} />
                    </div> */}
                     <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
        className="smallText"
    >
      <p style={{ display: "contents" }}>
        {isMobile
          ? "Why this test"
          : "Why do we conduct a Personality Test"}
      </p>
      <img src={questionmark} width={16} height={16} alt="?" />
    </div>
                  </div>

                  {quizSteps.map((step, index) => (
                    <div
                      className={`d-flex align-items-center techQzboxexit ${step.variant ? `variant-${step.variant}` : ""
                        }`}
                      key={index}
                      style={{ backgroundColor: step.variant }}
                    >
                      <div
                        className="icon-wrapperexit"
                        style={{ backgroundColor: step.smallbox }}
                      >
                        <img
                        className="img-tic-media"
                          src={step.icon}
                          alt="icon"
                          width={16}
                          height={16}
                        />
                      </div>
                      <div className="text-wrapper">
                        <p
                          className="info-title"
                          style={{ marginBottom: "0px" }}
                        >
                          {step.title}
                        </p>
                        <p
                          className="info-subtitle"
                          style={{ marginBottom: "0px" }}
                        >
                          {step.subtitle}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="neWbTnAreaWrap">
                  <div
                    className="btnLywo1"
                    onClick={() => {
                      navigate("/CompanyName");
                      // setShowRedirectModal(true)
                    }}
                  >
                    <p>Let’s Start the Test</p>
                    <img src={arrowRight} className="mobIcon" alt="start" />
                  </div>
                  {/* <div className="btnLywo1" onClick={() => setShowRedirectModal(true)}> 
  <p>Let’s Start the Test</p>
  <img src={arrowRight} className="mobIcon" alt="start" />
</div> */}

                  <div
                    className="btnLywo2exttt"
                    onClick={() => setShowExitModal(true)}
                  >
                    <p style={{ color: "#3538CD", fontWeight: 600 }}>
                      Return Later to complete
                    </p>
                    <img
                      src={saveIcon}
                      className="mobIcon"
                      alt="save"
                      width={15}
                      height={15}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dsktp-footer">
          <div className="dsktp-footer-right">
            {/* <div className='lang-dsktp'>
                           <img src={languageIcon} className="mobIcon" alt="Select language" />
                           <p>Behavior test Language</p>
                           <div className='langbox-dsktp' onClick={() => setShowLanguagePopup(true)}>
                               <p>English</p>
                               <img src={arrowUp} className="mobIcon" alt="Select language" />
                           </div>
                       </div> */}

            <button
              className="comp-savebtn"
              onClick={editProfile}
              style={{ width: "120px", padding: "8px 14px", height: "40px" }}
            >
              Edit Profile
            </button>
          </div>
          <div className="dsktp-footer-left">
            <div className="dsktp-footerjob-info">
              <div className="v-u-jobcode">
                <h6 style={{ display: "flex", justifyContent: "end" }}>
                  JOB-2024-001
                </h6>
                <p>
                  This application Process is Managed by <span>LYWO</span>
                </p>
              </div>
              <div className="v-u-bg">
                <img src={VerifiedUserWhite} className="vu-icon" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-icons-mcq">

          <div className="mobile-icon-txt" onClick={editProfile}>
            <img src={editProfileIcon} className="mobIcon" alt="Edit Profile" />
            <p>Edit Profile</p>
          </div>
        </div>
      </div>
    </>
  );
}
